<template>
  <el-dialog title="结束工单" :visible.sync="visible" width="650px" custom-class="repair-design-dialog" @close="resetForm">
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px" class="repair-dialog-form">
      <el-form-item label="结束原因" prop="reasonType">
        <el-select v-model="formData.reasonType" placeholder="请选择结束原因" style="width: 100%">
          <el-option label="误报" value="误报" />
          <el-option label="已完成处理" value="已完成处理" />
          <el-option label="设备恢复正常" value="设备恢复正常" />
          <el-option label="其他" value="其他" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="formData.reasonType === '其他'" label="详细原因" prop="otherReason">
        <el-input
          v-model="formData.otherReason"
          type="textarea"
          :rows="3"
          placeholder="请输入详细原因"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer repair-dialog-footer">
      <el-button class="dialog-cancel-btn" @click="visible = false">取消</el-button>
      <el-button type="primary" class="dialog-submit-btn" @click="submitForm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { endInspectionWork } from '@/api/inspection/workPoolApi'

export default {
  name: 'EndWorkOrder',
  data() {
    return {
      visible: false,
      formData: {
        workId: '',
        reasonType: '',
        otherReason: ''
      },
      rules: {
        reasonType: [{ required: true, message: '请选择结束原因', trigger: 'change' }],
        otherReason: [{ required: true, message: '请输入详细原因', trigger: 'blur' }]
      }
    }
  },
  methods: {
    open(work) {
      this.formData.workId = work.id
      this.visible = true
    },

    async submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            // 如果选择了"其他"，使用详细原因；否则使用选择的原因类型
            const context = this.formData.reasonType === '其他'
              ? this.formData.otherReason
              : this.formData.reasonType

            await endInspectionWork({ id: this.formData.workId, context })
            this.$message.success('操作成功')
            this.visible = false
            this.$emit('success')
          } catch (error) {
            this.$message.error(error.message || '操作失败')
          }
        }
      })
    },

    resetForm() {
      this.$refs.form && this.$refs.form.resetFields()
      this.formData = {
        workId: '',
        reasonType: '',
        otherReason: ''
      }
    }
  }
}
</script>

<style scoped>
.repair-dialog-form { padding: 8px 24px 0; }
.repair-dialog-form >>> .el-form-item { margin-bottom: 24px; }
.repair-dialog-form >>> .el-form-item__label { color: #1D2129; font-weight: 400; white-space: nowrap; }
.repair-dialog-form >>> .el-input__inner,
.repair-dialog-form >>> .el-textarea__inner { height: 38px; border-radius: 8px; border-color: #DCE6F5; }
.repair-dialog-form >>> .el-textarea__inner { height: auto; min-height: 80px; }
.repair-dialog-footer { display: flex; justify-content: flex-end; gap: 12px; }
.dialog-cancel-btn, .dialog-submit-btn { width: 74px; height: 38px; padding: 0; border-radius: 10px; }
.dialog-cancel-btn { color: #0E76FF; border-color: #0E76FF; background: #fff; }
.dialog-submit-btn { background: #0E76FF; border-color: #0E76FF; }
</style>
